<template>
  <div class="product-list-manage">
    <!-- 搜索工具栏 -->
    <div class="toolbar">
      <div style="padding: 5px 0;">
        栏目名称：
        <el-cascader
          v-model="searchForm.category_id"
          :options="categoryTreeData"
          :props="{ value: 'id', label: 'text', children: 'children', expandTrigger: 'hover', emitPath: false }"
          placeholder="请选择栏目"
          style="width: 200px; margin-right: 10px"
          clearable
          @change="handleCategoryChange"
        />
        <el-button type="primary" @click="handleSearch">搜索</el-button>
        <el-button @click="handleShowAll">全部</el-button>
        
        <div style="float: right">
          <el-button type="warning" @click="handleAppSort">App精研产品排序</el-button>
        </div>
      </div>
      <div style="color: darkred; margin-top: 5px;">
        备注：页面默认为H5产品排序，App排序点击右侧[App精研产品排序]进行设置，可在栏目名称中设置App产品中心子栏目产品排序。
      </div>
    </div>

    <!-- 数据表格 -->
    <el-table
      :data="tableData"
      v-loading="loading"
      border
      stripe
      style="width: 100%"
      :height="calculateTableHeight()"
    >
      <el-table-column prop="frequency_type" label="类别" align="center">
        <template slot-scope="scope">
          {{ formatFrequencyType(scope.row.frequency_type) }}
        </template>
      </el-table-column>
      
      <el-table-column prop="product_name" label="产品名称" align="center" />
      
      <el-table-column prop="min_premium" label="产品价格(元/起)" align="center" />
      
      <el-table-column prop="updated_at" width="180" label="添加时间" align="center">
        <template slot-scope="scope">
          {{ formatDate(scope.row.updated_at) }}
        </template>
      </el-table-column>
      
      <el-table-column prop="operator" label="添加人" align="center" />
      
      <el-table-column prop="disabled" label="状态" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.disabled ? 'danger' : 'success'">
            {{ scope.row.disabled ? '禁用' : '启用' }}
          </el-tag>
        </template>
      </el-table-column>
      
      <el-table-column label="操作" width="250" align="center">
        <template slot-scope="scope">
          <el-button size="mini" type="text" @click="handleMoveUp(scope.row)" style="color: darkgreen;">上移</el-button>
          <el-button size="mini" type="text" @click="handleView(scope.row)" style="color: darkgreen;">查看</el-button>
          <el-button 
            v-if="scope.row.disabled"
            size="mini" 
            type="text" 
            @click="handleEdit(scope.row)"
            style="color: darkgreen;"
          >
            编辑
          </el-button>
          <el-button 
            v-if="scope.row.disabled" 
            size="mini" 
            type="text" 
            @click="handleToggleStatus(scope.row)"
            style="color: darkgreen;"
          >
            启用
          </el-button>
          <el-button 
            v-else 
            size="mini" 
            type="text" 
            @click="handleToggleStatus(scope.row)"
            style="color: darkgreen;"
          >
            禁用
          </el-button>
          <el-button 
            v-if="scope.row.disabled" 
            size="mini" 
            type="text" 
            @click="handleDelete(scope.row)"
            style="color: darkgreen;"
          >
            删除
          </el-button>
          <el-button size="mini" type="text" @click="handleMoveDown(scope.row)" style="color: darkgreen;">下移</el-button>
          <el-button 
            v-if="currentCategoryId && showTopButton"
            size="mini" 
            type="text" 
            @click="handleMoveTop(scope.row)"
            style="color: darkgreen;"
          >
            置顶
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 编辑对话框 -->
    <ProductListEditDialog
      :visible.sync="editDialogVisible"
      :product-data="currentProduct"
      :app-info="appInfo"
      :category-list="categoryTreeData"
      @refresh="loadProductList"
    />

    <!-- App精研产品排序对话框 -->
    <AppProductSortDialog
      :visible.sync="appSortDialogVisible"
      :app-info="appInfo"
      @refresh="loadProductList"
    />
  </div>
</template>

<script>
import { 
  getProductList, 
  toggleProductStatus, 
  deleteProduct, 
  getProductColumnList,
  sortProduct
} from '@/api/custom-frontend'
import ProductListEditDialog from './ProductListEditDialog.vue'
import AppProductSortDialog from './AppProductSortDialog.vue'

export default {
  name: 'ProductListManage',
  components: {
    ProductListEditDialog,
    AppProductSortDialog
  },
  props: {
    appInfo: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      tableData: [],
      categoryTreeData: [], // 栏目树形数据
      searchForm: {
        category_id: null // 修改为栏目 ID
      },
      currentCategoryId: null, // 当前选中的栏目 ID
      showTopButton: false, // 是否显示置顶按钮
      editDialogVisible: false,
      currentProduct: null,
      appSortDialogVisible: false // App精研产品排序对话框显示状态
    }
  },
  watch: {
    appInfo: {
      handler(newVal) {
        if (newVal && newVal.id) {
          this.loadCategoryList()
          this.loadProductList()
        }
      },
      immediate: true
    }
  },
  methods: {
    async loadCategoryList() {
      if (!this.appInfo.id) return
      
      try {
        const res = await getProductColumnList({
          app_id: this.appInfo.id,
          type: 3
        })
        if (res && res.err_code === 0) {
          const rawData = res.rows || []
          this.categoryTreeData = this.convertToTreeData(rawData)
        }
      } catch (error) {
        console.error('获取产品栏目列表失败:', error)
      }
    },
    
    // 将数据转换为 combotree 需要的树形结构
    convertToTreeData(data) {
      const store = {}
      
      // 建立映射关系
      data.forEach(item => {
        item.text = item.name // combotree 需要 text 字段
        if (!store[item.parent_id || 0]) {
          store[item.parent_id || 0] = []
        }
        store[item.parent_id || 0].push(item)
      })
      
      // 构建树形结构
      data.forEach(item => {
        if (store[item.id]) {
          item.children = store[item.id]
        }
      })
      
      return store[0] || []
    },
    
    async loadProductList() {
      if (!this.appInfo.id) return
      
      this.loading = true
      try {
        const params = {
          app_id: this.appInfo.id,
          os_type: this.appInfo.os_type || 1
        }
        
        // 如果有选中的栏目，添加到参数中
        if (this.currentCategoryId) {
          params.category_id = this.currentCategoryId
        }
        
        const res = await getProductList(params)
        if (res && res.err_code === 0) {
          this.tableData = res.rows || []
          // 保存到 localStorage 以便导入时判断重复
          window.localStorage['product'] = JSON.stringify(res)
        }
      } catch (error) {
        console.error('获取产品列表失败:', error)
        this.$message.error('获取产品列表失败')
      } finally {
        this.loading = false
      }
    },
    
    handleCategoryChange(value) {
      this.currentCategoryId = value
      this.showTopButton = !!value // 只有选中栏目时才显示置顶按钮
    },
    
    handleSearch() {
      this.loadProductList()
    },
    
    handleShowAll() {
      this.searchForm = { category_id: null }
      this.currentCategoryId = null
      this.showTopButton = false
      this.loadProductList()
    },
    
    handleAppSort() {
      // 打开App精研产品排序对话框
      this.appSortDialogVisible = true
    },
    
    handleView(row) {
      this.currentProduct = { ...row, action: 'view' }
      this.editDialogVisible = true
    },
    
    handleEdit(row) {
      this.currentProduct = { ...row }
      this.editDialogVisible = true
    },
    
    async handleToggleStatus(row) {
      const action = row.disabled ? '启用' : '禁用'
      try {
        await this.$confirm(`确认要${action}该产品吗？`, '确认操作', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        
        const res = await toggleProductStatus({
          id: row.id,
          disabled: !row.disabled
        })
        
        if (res && res.err_code === 0) {
          this.$message.success(`${action}成功`)
          this.loadProductList()
        } else {
          this.$message.error(res.err_msg || `${action}失败`)
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error(`${action}产品失败:`, error)
          this.$message.error(`${action}失败`)
        }
      }
    },
    
    async handleDelete(row) {
      try {
        await this.$confirm('确认要删除该产品吗？', '确认删除', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        
        const res = await deleteProduct({ id: row.id })
        if (res && res.err_code === 0) {
          this.$message.success('删除成功')
          this.loadProductList()
        } else {
          this.$message.error(res.err_msg || '删除失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除产品失败:', error)
          this.$message.error('删除失败')
        }
      }
    },
    
    formatFrequencyType(value) {
      return value === 1 ? '单票' : '年保'
    },
    
    formatDate(value) {
      if (!value || value == null) return '-'
      
      // 尝试解析时间，支持多种格式
      let date
      if (typeof value === 'string') {
        date = new Date(value)
      } else if (typeof value === 'number') {
        // 判断是秒还是毫秒时间戳
        date = value > 10000000000 ? new Date(value) : new Date(value * 1000)
      } else {
        date = new Date(value)
      }
      
      // 检查日期是否有效
      if (isNaN(date.getTime()) || date.getFullYear() <= 1970) {
        return '-'
      }
      
      // 格式化为 yyyy-MM-dd HH:mm:ss
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    
    calculateTableHeight() {
      // 计算页面高度 - 工具栏高度 - 标签页头部高度 - 其他间距
      const windowHeight = window.innerHeight
      const toolbarHeight = 120  // 工具栏高度（包括备注）
      const tabsHeaderHeight = 55  // 标签页头部高度
      const padding = 40  // 内边距
      
      const height = windowHeight - toolbarHeight - tabsHeaderHeight - padding
      
      // 最小高度限制
      return height > 300 ? height : 300
    },
    
    async handleMoveUp(row) {
      try {
        const data = {
          app_id: this.appInfo.id,
          app_product_id: row.id
        }
        
        if (this.currentCategoryId) {
          data.category_id = this.currentCategoryId
        }
        
        const res = await sortProduct({ ...data, action: 'up' })
        if (res && res.err_code === 0) {
          this.loadProductList()
        } else {
          this.$message.error(res.err_msg || '上移失败')
        }
      } catch (error) {
        console.error('上移失败:', error)
        this.$message.error('上移失败')
      }
    },
    
    async handleMoveDown(row) {
      try {
        const data = {
          app_id: this.appInfo.id,
          app_product_id: row.id
        }
        
        if (this.currentCategoryId) {
          data.category_id = this.currentCategoryId
        }
        
        const res = await sortProduct({ ...data, action: 'down' })
        if (res && res.err_code === 0) {
          this.loadProductList()
        } else {
          this.$message.error(res.err_msg || '下移失败')
        }
      } catch (error) {
        console.error('下移失败:', error)
        this.$message.error('下移失败')
      }
    },
    
    async handleMoveTop(row) {
      try {
        const data = {
          app_id: this.appInfo.id,
          app_product_id: row.id,
          category_id: this.currentCategoryId
        }
        
        const res = await sortProduct({ ...data, action: 'top' })
        if (res && res.err_code === 0) {
          this.loadProductList()
        } else {
          this.$message.error(res.err_msg || '置顶失败')
        }
      } catch (error) {
        console.error('置顶失败:', error)
        this.$message.error('置顶失败')
      }
    },
  }
}
</script>

<style lang="less" scoped>
.product-list-manage {
  padding: 20px;
  height: 100%;
  
  .toolbar {
    padding: 8px 0;
    margin-bottom: 20px;
    border-bottom: 1px solid #e6e6e6;
    
    .search-label {
      margin-right: 10px;
      font-weight: bold;
    }
    
    label {
      margin-right: 5px;
    }
    
    .el-button {
      margin-left: 5px;
    }
  }
}
</style>